/**
 * TTS 资源库管理 API 服务
 */
import { request } from '@/api/client'

// TTS 音频接口定义
export interface TTSAudio {
  id: number
  content_hash: string
  text_content?: string
  text_length: number
  language_code: string
  audio_url: string
  audio_duration_seconds?: number
  audio_file_size_bytes?: number
  provider: string
  voice_id: string
  model?: string
  voice_settings?: Record<string, unknown> | null
  generation_status: 'pending' | 'generating' | 'completed' | 'failed'
  generated_at?: string
  error_message?: string
  cost_usd?: number
  usage_count: number
  last_used_at?: string
  created_at: string
  updated_at: string
}

// TTS 列表查询参数
export interface TTSListParams {
  page?: number
  page_size?: number
  search?: string
  provider?: string
  generation_status?: string
}

// TTS 列表响应
export interface TTSListResponse {
  total: number
  items: TTSAudio[]
  page: number
  page_size: number
}

const API_PREFIX = '/api/v1/admin/tts'

export const ttsApi = {
  /**
   * 获取 TTS 音频列表
   */
  getList(params?: TTSListParams) {
    return request.get<TTSListResponse>(API_PREFIX, { params })
  },

  /**
   * 删除 TTS 音频
   */
  delete(audioId: number) {
    return request.delete<{ message: string; id: number }>(`${API_PREFIX}/${audioId}`)
  },

  /**
   * 批量删除 TTS 音频
   */
  batchDelete(audioIds: number[]) {
    return request.delete<{ message: string; deleted_count: number }>(`${API_PREFIX}/batch`, {
      data: { audio_ids: audioIds }
    })
  }
}
